import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Input } from '../ui/input';
import { API_URL, CATEGORIES } from './shared';

// value: { project_id, category }
export const PlacePicker = ({ value, onChange, testid }) => {
  const [projects, setProjects] = useState([]);
  const [q, setQ] = useState('');
  useEffect(() => {
    const t = setTimeout(() => axios.get(`${API_URL}/godziny/projects`, { params: { q } }).then((r) => setProjects(r.data)).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q]);
  const current = value.project_id ? `p:${value.project_id}` : value.category ? `c:${value.category}` : '';
  const pick = (v) => onChange(v.startsWith('p:') ? { project_id: v.slice(2), category: null } : { project_id: null, category: v.slice(2) });
  return (
    <div className="space-y-2">
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Szukaj zlecenia (klient, adres)" data-testid={`${testid}-search`}
        className="bg-[var(--crm-bg-panel)] border-[var(--crm-border)]" />
      <Select value={current} onValueChange={pick}>
        <SelectTrigger className="bg-[var(--crm-bg-panel)] border-[var(--crm-border)]" data-testid={`${testid}-select`}>
          <SelectValue placeholder="Wybierz zlecenie lub kategorię" />
        </SelectTrigger>
        <SelectContent className="max-h-72">
          {CATEGORIES.map((c) => <SelectItem key={c.id} value={`c:${c.id}`}>{c.label}</SelectItem>)}
          {projects.map((p) => <SelectItem key={p.id} value={`p:${p.id}`}>{p.nazwa} – {p.klient}{p.miejscowosc ? `, ${p.miejscowosc}` : ''}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
};

export const ConflictWarning = ({ conflicts, testid }) => (!conflicts?.length ? null : (
  <div className="text-xs rounded-md border border-red-500/40 bg-red-500/10 text-red-500 p-2" data-testid={testid}>
    Uwaga – możliwe podwójne liczenie: w tym dniu są już nakładające się godziny{' '}
    {conflicts.map((c) => `${c.start}–${c.end} (${c.status === 'approved' ? 'zatwierdzone' : 'oczekuje'}, ${c.source === 'office' ? 'biuro' : 'portal'})`).join(', ')}.
  </div>
));
